export const DEFAULT_IMAGE_SEARCH_QUERY = '--default--';
export const DEFAULT_IMAGE_SEARCH_RESULT = 'DEFAULT_IMAGE_SEARCH_RESULT';
